module.exports = __webpack_public_path__ + "img/[快哭了].b7e5d291.svg";